/* SolarBalls — Shop by Category carousel.
   Wires every [data-sbh-cat] section: arrows, drag-to-scroll, and an optional
   auto-swipe that loops seamlessly (cards are cloned once the row overflows).
   Auto-swipe pauses on touch / drag / keyboard focus, when the section is off screen or the
   tab is hidden, and never runs for prefers-reduced-motion or in the theme editor. */
(function(){
  if (window.SBCategories) return;

  function init(root){
    if (!root || root.dataset.sbhCatInit) return;
    var track = root.querySelector('[data-sbh-track]');
    if (!track) return;
    root.dataset.sbhCatInit = '1';

    var prev = root.querySelector('[data-sbh-prev]'), next = root.querySelector('[data-sbh-next]');
    var originals = Array.prototype.slice.call(track.querySelectorAll('.sbh-cat__card'));
    if (!originals.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var wantAuto = root.dataset.autoplay === 'true' && !reduced && !editor;
    var delay = Math.max(2, parseFloat(root.dataset.speed) || 3.5) * 1000;
    var looping = false, timer = null, hold = null, visible = true, paused = false;

    function gap(){ return parseFloat(getComputedStyle(track).columnGap) || 16; }
    function step(){ return originals[0].getBoundingClientRect().width + gap(); }
    function setWidth(){ return step() * originals.length; }
    function scrollable(){ return getComputedStyle(track).overflowX !== 'visible'; }

    function removeClones(){
      Array.prototype.slice.call(track.querySelectorAll('[data-sbh-clone]')).forEach(function(n){ n.remove(); });
      looping = false;
    }
    /* Clone the card set (twice when one set is narrower than the viewport) so the
       row can wrap without a visible jump. Only when auto-swipe is on and the row scrolls. */
    function buildLoop(){
      removeClones();
      if (!wantAuto || !scrollable()) return;
      if (track.scrollWidth <= track.clientWidth + 4) return;   // everything already fits
      var sets = setWidth() >= track.clientWidth ? 1 : 2;
      for (var s = 0; s < sets; s++){
        originals.forEach(function(card){
          var c = card.cloneNode(true);
          c.setAttribute('data-sbh-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('tabindex', '-1');
          c.removeAttribute('id');
          c.removeAttribute('data-shopify-editor-block');
          track.appendChild(c);
        });
      }
      looping = true;
    }
    function jump(x){ var b = track.style.scrollBehavior; track.style.scrollBehavior = 'auto'; track.scrollLeft = x; track.style.scrollBehavior = b; }
    /* once a scroll settles past the original set, snap back by exactly one set width */
    function wrap(){ if (!looping) return; var w = setWidth(); if (track.scrollLeft >= w - 2) jump(track.scrollLeft - w); }

    function update(){
      if (looping){ if (prev) prev.disabled = false; if (next) next.disabled = false; return; }
      var max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function go(dir){
      if (looping && dir < 0 && track.scrollLeft <= 2) jump(setWidth());
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    function stop(){ clearInterval(timer); timer = null; }
    function start(){
      stop();
      if (!looping || paused || !visible || document.hidden) return;
      timer = setInterval(function(){ go(1); }, delay);
    }
    function pause(){ paused = true; clearTimeout(hold); stop(); }
    function resume(after){ clearTimeout(hold); hold = setTimeout(function(){ paused = false; start(); }, after || 0); }

    if (prev) prev.addEventListener('click', function(){ go(-1); pause(); resume(delay); });
    if (next) next.addEventListener('click', function(){ go(1); pause(); resume(delay); });

    var settle;
    track.addEventListener('scroll', function(){
      clearTimeout(settle);
      settle = setTimeout(function(){ wrap(); update(); }, 140);
    }, { passive: true });

    /* keyboard focus pauses; mouse hover deliberately does not (the row keeps sliding) */
    root.addEventListener('focusin', function(e){ if (e.target.matches && e.target.matches(':focus-visible')) pause(); });
    root.addEventListener('focusout', function(){ resume(0); });
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', function(){ resume(delay); }, { passive: true });
    document.addEventListener('visibilitychange', start);
    if ('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){ visible = entries[0].isIntersecting; start(); }, { threshold: 0.2 }).observe(root);
    }

    /* drag-to-scroll (mouse/trackpad press-drag) */
    var down = false, sx = 0, ss = 0, moved = false;
    track.addEventListener('pointerdown', function(e){ if (e.pointerType === 'touch' || !scrollable()) return; down = true; pause(); moved = false; sx = e.clientX; ss = track.scrollLeft; });
    window.addEventListener('pointermove', function(e){ if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4){ moved = true; track.classList.add('is-dragging'); } track.scrollLeft = ss - dx; });
    window.addEventListener('pointerup', function(){ if (down){ down = false; resume(delay); setTimeout(function(){ track.classList.remove('is-dragging'); }, 0); } });
    track.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function(e){ e.preventDefault(); });

    function layout(){ var keep = looping ? track.scrollLeft % setWidth() : track.scrollLeft; buildLoop(); jump(looping ? keep % setWidth() : keep); update(); start(); }
    var rz; window.addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(layout, 180); });
    layout();
  }

  function initAll(){ document.querySelectorAll('[data-sbh-cat]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);

  window.SBCategories = { init: initAll };
})();
